<div class="modal-header customBlueHeader">
  <p class="modal-title">Order Reject</p>
  
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body customModalBody">
    
    <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
    <form [formGroup]="orderRejectForm" (ngSubmit)="orderReject(orderRejectForm)">


        <div class="form-group">
            <label>Select Reason Type</label>
            <select class="form-control col-form-label-sm" formControlName="reason"  >
              <!-- <option>Select</option> -->
              <option [ngValue]="null" disabled>Select</option>
              <option  *ngFor="let orderRejectType of listOfReasons" value={{orderRejectType}}>
                {{orderRejectType}} 
      
              </option>
            </select>
          </div>

          <!-- <div class="form-group">
            <label>Select Sub Reason Type</label>
            <select class="form-control col-form-label-sm" formControlName="reasonType">
              <option>Select</option>
              <option  *ngFor="let orderCancelType of orderCancelTypes" value={{orderCancelType.id}}>
                {{orderCancelType.name}} 
      
              </option>
            </select>
          </div> -->

          <!-- <div class="form-group">
            <label>Reason</label>
            <textarea class="form-control col-form-label-sm" formControlName="reason"></textarea>
          </div> -->
      
          <div class="modal-footer customModalFooter customModalFooter">
            <button  class="btn closeGreenBordBtn" (click)="close()" >Close</button>
            <button type="submit" class="btn green_btn" [disabled]="!isButtonEnable">Order Reject</button>
          </div>
        </form>


</div>